module.exports = __webpack_public_path__ + "static/media/IHMUpdated.7140b7ed.svg";